import { ApiErrorCode, withApiErrorHandler } from '@/modules/common/api/errors';
import { EntityTypeDTO } from '@/modules/common/types/dto/response/entity-type-dto';
import { IntegrationProviderDTO } from '@/modules/common/types/dto/response/integration-response';
import { axiosInstance } from '@/utils/axios';

/**
 * Request body for synchronizing entities from integrations
 */
export interface SynchronizeEntitiesRequest {
  entities?: EntityTypeDTO[];
  integrations?: IntegrationProviderDTO[];
}

/**
 * Synchronizes entities for specific integration
 * Triggers data refresh from the connected integration service
 *
 * @param request - Optional request body with entities and integrations to sync
 */
export const synchronizeIntegration = async (
  request?: SynchronizeEntitiesRequest
): Promise<void> => {
  const endpoint = '/api/integrations/synchronize';

  await withApiErrorHandler(endpoint, ApiErrorCode.INTEGRATION_SYNC_FAILED, () =>
    axiosInstance.post(endpoint, request || {})
  );
};
